var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08398 5.41683H10.9173V7.25016H9.08398V5.41683ZM9.08398 9.0835H10.9173V14.5835H9.08398V9.0835ZM10.0007 0.833496C4.94065 0.833496 0.833984 4.94016 0.833984 10.0002C0.833984 15.0602 4.94065 19.1668 10.0007 19.1668C15.0607 19.1668 19.1673 15.0602 19.1673 10.0002C19.1673 4.94016 15.0607 0.833496 10.0007 0.833496ZM10.0007 17.3335C5.95815 17.3335 2.66732 14.0427 2.66732 10.0002C2.66732 5.95766 5.95815 2.66683 10.0007 2.66683C14.0431 2.66683 17.334 5.95766 17.334 10.0002C17.334 14.0427 14.0431 17.3335 10.0007 17.3335Z",
    fill: "#67A9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.59ffcd959d6edff1c55f7c5f4c0533b1.svg";
export { ForwardRef as ReactComponent };